import { GoogleLogin } from "@react-oauth/google";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import useAuthStore from "../store/authStore";

/**
 * "Continue with Google" button + "OR" divider, used on /login and /register.
 *
 * Uses Google's One-Tap / popup flow — no redirect, no session middleware. The
 * frontend gets back an ID token (JWT) which we POST to /api/auth/google for
 * server-side verification + auto-merge with existing accounts.
 *
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
export default function GoogleSignInButton({ redirectTo = "/dashboard" }) {
  const { loginWithGoogle } = useAuthStore();
  const navigate = useNavigate();

  const handleSuccess = async (response) => {
    if (!response?.credential) {
      toast.error("Google did not return a credential");
      return;
    }
    try {
      const user = await loginWithGoogle(response.credential);
      toast.success(`Welcome, ${user.name?.split(" ")[0] || "back"}!`);
      navigate(redirectTo);
    } catch (err) {
      toast.error(err.message || "Google sign-in failed");
    }
  };

  const handleError = () => {
    toast.error("Google sign-in was cancelled or failed");
  };

  return (
    <div className="space-y-3" data-testid="google-signin-section">
      <div className="flex items-center gap-3 my-2">
        <div className="flex-1 h-px bg-slate-200" />
        <span className="text-[11px] font-semibold uppercase tracking-wider text-slate-400">OR</span>
        <div className="flex-1 h-px bg-slate-200" />
      </div>
      <div className="flex justify-center" data-testid="google-signin-btn">
        <GoogleLogin
          onSuccess={handleSuccess}
          onError={handleError}
          theme="outline"
          size="large"
          text="continue_with"
          shape="pill"
          width="320"
        />
      </div>
    </div>
  );
}
